export default {
    dashboardv2: {
        usersByStatus: "Users By Status",
        allTime: "All Time",
        noOfUsers: "No. of Users",
        usersByGender: "Users By gender",
        gender: "Gender",
        farmerName: "Farmer Name",
        farmerProduction: "Farmer Production",
        production: "Production",
        plan: "Plan",
        expiryDate: "Expiry Date",
        buyingStationProduction: "Buying station Production",
        dryMillingProduction: "Dry Milling Production",
        usersPerMembershipPlans: "Users Per Membership Plans",
        planType: "Plan Type",
        users: "Users",
        planValidity: "Plans Validity",
        averageSellingPriceByAllFarmers: "Average Selling Price by All Farmers",
        avgSellingPrice: "Avg. Selling Price",
        pricePaid: "Price Paid",
        avgSellingPricePerFarmer: "Average Selling Price per Farmer",
        exportAsCSV: "Export As CSV",
        exportAsXLS: "Export As XLS",
    
        filterByFarm: "Filter By Farms",
        searchFarms: "Search Farms",
        filterByRegion: "Filter By Region",
        filterByFarmer: "Filter by farmer",
      },

      dashboardSection: {
        greenBeansData: "Green Beans Management",
        greenCoffee: "Green Coffee",
        dryMilling: "Dry Milling",
        modules: "Modules",
        allowances: "Allowances",
        maxUserAllowed: "Max Users Allowed ",
        satelliteReportsAllowed: "Satellite Reports Allowed ",
        advanceReport: "Advanced Reports Allowed ",
        subscriptionUpTo: "Subscription Up To",
        roleAllowed: "Roles Allowed ",
        moduleAllowed: "Modules Allowed ",
        registeredUsers: "Registered Users",
        validMemberships: "Valid Memberships",
        activeUsers: "Active Users",
        deactivatedUsers: "Deactivated Users",
        membershipValidity: "Membership Validity",
        lessThan1Month: "Less Than 1 Month",
        months1to6: "1-6 Months",
        months6to12: "6-12 Months",
        moreThan1Year: "More than 1 year ",
        cropOverview: "Crop Overview",
        buySellOverview: "Buy/Sell Overview",
        plantations: "Plantations ",
        coffeeData: "Coffee Data",
        availableModules: "Available Modules",
        roleList: "Farmer, Buying Station, Warehouse",
        memberData: "Member Data",
        userType: "User Type",
        registered: "Registered",
        offlineUsers: "Offline Users",
        lessThanOneMonth: "< 1 Month",
        cacaoData: "Cacao Data",
        dryCacao: "Dry Cacao",
        traceability: "Traceability",
        allFarm: "All Farms",
      },
      greenBeansData: {
        notFound: "No data found",
      },

      dashboardReports: {
        appDataReports: "App Data Reports",
        reports: "Reports",
      },
}